import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ADMIN,
    APPROVED,
    HOSPITAL,
    INDIVIDUAL,
    NURSE,
    WAITING,
} from '@constants/constants';
import {
    adminCreateUser,
    getUserIDInfo,
    getUserInfo,
    getUserName,
    handleFetchLogo,
} from '@utils/utils';
import {
    INDIVIDUAL_USER_PATH,
    HOSPITAL_USER_PATH,
    NURSE_PATH,
    NURSE_USER_PATH,
} from '@constants/routes';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useParams, Link } from 'react-router-dom';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import SharpeInfoIcon from '@components/SvgComponents/SharpInfoIcon';
import { useAppSelector } from '@store/hooks';
import { useAppDispatch } from '@store/hooks';
import { setUserRole } from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import HospitalForm from './Form/HospitalForm';
import NurseForm from './Form/NurseForm';
import IndividualForm from './Form/IndividualForm';
import {
    PutItemCommand,
    DynamoDBClient,
    GetItemCommand,
    ScanCommand,
} from '@aws-sdk/client-dynamodb';
import { v4 as uuidv4 } from 'uuid';
import {
    S3Client,
    PutObjectCommand,
    ObjectCannedACL,
    ServerSideEncryption,
    GetObjectCommand,
} from '@aws-sdk/client-s3';
import {
    AdminGetUserCommand,
    CognitoIdentityProviderClient,
} from '@aws-sdk/client-cognito-identity-provider';
import ErrorMessage from '@components/Error/ErrorMessage';

import awsConfig from '../amplifyconfiguration.json';
import { ConsoleLogger } from 'aws-amplify/utils';
import { FaArrowLeftLong } from 'react-icons/fa6';
import {
    checkHospitalList,
    getUserAttributes,
    userInfo,
} from '@utils/authUtils';
import SuccessPopUp from './SuccessPopUpComponent';
import {
    setHospitalDetail,
    setUserDetail,
    setUserDeviceList,
} from '@store/reducers/userSlice';
import UserRole from '../views/pages/auth/UserRole';
import {
    COGNITO_USER_ID,
    TENANT_ID,
    USER_EMAIL,
    USER_MOBILE_NUMBER,
    USER_ROLE,
} from '@constants/cognitoAttributes';
import { setNurseDetail } from '../store/reducers/userSlice';
import { checkDeviceIdExists } from '@utils/deviceUtils';
import { hospitalUserInfo } from '@utils/hospitalUtils';
import { getDataUsingHospitalId, getDataUsingUserId } from '@utils/sharedUtils';
import { HOSPITALS_TABLE } from '@constants/dynamoDBTableName';
import { useAuditLog } from '../contexts/AuditLogContext';

interface UserDeviceList {
    id: number;
    device_id: string;
    create_date: string;
}

const CreateUser: React.FC = () => {
    // const [name, setName] = useState('');
    // const [email, setEmail] = useState('');
    // const [mobileNo, setMobileNo] = useState('');
    // const [password, setPassword] = useState('');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useAppDispatch();
    const email = useAppSelector((state) => state.signup.email);
    const mobileNumber = useAppSelector((state) => state.signup.mobileNumber);
    const password = useAppSelector((state) => state.signup.password);
    const [buttonText, setButtonText] = useState('');
    const deviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userEmail = useAppSelector((state) => state.signup.email);
    const UserMobileNumber = useAppSelector(
        (state) => state.signup.mobileNumber
    );
    const userPassword = useAppSelector((state) => state.signup.password);
    const userDeviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userRole = useAppSelector((state) => state.signup.userRole);
    const userState = useAppSelector((state) => state.signup.userState);
    const userName = useAppSelector((state) => state.signup.name);
    const hospitalName = useAppSelector((state) => state.signup.hospital_name);
    const hospitalBranchName = useAppSelector(
        (state) => state.signup.hospital_branch
    );
    const adminHospitalName = useAppSelector((state) => state.signup.name);
    const hospitalID = useAppSelector((state) => state.signup.hospital_id);
    const hospitalWebsite = useAppSelector(
        (state) => state.signup.hospital_website
    );
    const hospitalEmailID = useAppSelector((state) => state.signup.email_id);
    const hospitalContactNumber = useAppSelector(
        (state) => state.signup.contact_no
    );
    const hospitalGST = useAppSelector((state) => state.signup.gst_no);
    const logo = useAppSelector((state) => state.signup.logo);
    const logo_name = useAppSelector((state) => state.signup.logo_name);
    const logo_url = useAppSelector((state) => state.signup.logo_url);
    const logo_type = useAppSelector((state) => state.signup.logo_type);
    const userAddressOne = useAppSelector((state) => state.signup.address_one);
    const userAddressTwo = useAppSelector((state) => state.signup.address_two);
    const userCity = useAppSelector((state) => state.signup.city);
    const userCountry = useAppSelector((state) => state.signup.country);
    const userPincode = useAppSelector((state) => state.signup.pincode);
    const { t } = useTranslation();
    const tenantUuid = uuidv4();
    const hospitalTenantUuid = uuidv4();
    const hospital_ID = uuidv4();
    const hospitalUuid = uuidv4();
    const hospitalInfoUuid = uuidv4();
    const userInfoUuid = uuidv4();
    const [userID, setUserID] = useState('');
    const [slugName, setSlugName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const loggedInUserRole = useAppSelector(
        (state) => state.login.loggedInUserRole
    );
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const hospitalTelephone = useAppSelector(
        (state) => state.signup.telephoneNumber
    );
    const loggedInUserID = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const { addLog } = useAuditLog();

    useEffect(() => {
        if (userRole == '') {
            const pathname = location.pathname;
            // // Check if the pathname matches any of the paths from AppConfig
            if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
                navigate(HOSPITAL_USER_PATH);
            } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
                navigate(INDIVIDUAL_USER_PATH);
            } else if (pathname.startsWith(NURSE_PATH + '/')) {
                navigate(NURSE_PATH);
            } else if (pathname.startsWith(NURSE_USER_PATH + '/')) {
                navigate(NURSE_USER_PATH);
            }
            // navigate(-1);
        }
        const updateButtonText = () => {
            const pathname = location.pathname;
            if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
                setButtonText('Add Individual');
            } else if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
                setButtonText('Add Hospital');
            } else if (pathname.startsWith(NURSE_PATH + '/')) {
                setButtonText('Add Nurse');
            } else if (pathname.startsWith(NURSE_USER_PATH + '/')) {
                setButtonText('Add Nurse');
            }
        };
        updateButtonText();
    }, [location.pathname, userRole, navigate]);

    // const validateForm = () => {
    //     const newErrors: { [key: string]: string } = {};
    //     if (!name) newErrors.name = 'Name is required';
    //     if (!email) newErrors.email = 'Email is required';
    //     if (!mobileNo) newErrors.mobileNo = 'Mobile number is required';
    //     // if (!password) newErrors.password = 'Password is required';
    //     else if (password.length < 6)
    //         newErrors.password = 'Password must be at least 6 characters';
    //     return newErrors;
    // };
    // const togglePasswordVisibility = () => {
    //     setShowPassword((prevShowPassword) => !prevShowPassword);
    // };

    function generateSlug(name: string) {
        const firstWord = name.split(' ')[0]; // Take only the first word
        const baseSlug = firstWord
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
            .replace(/(^-|-$)+/g, ''); // Remove leading and trailing hyphens
        const uniqueId = uuidv4().split('-')[0]; // Take a part of the UUID to ensure uniqueness
        return `${baseSlug}-${uniqueId}`;
    }



    function validateEmail(email: string) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    }

    const getItemFromDynamoDB = async (key: any) => {
        try {
            const response = await getDataUsingHospitalId(HOSPITALS_TABLE, key);

            if (response && response.Items && response.Items.length > 0) {
                const data = response.Items[0];
                const status = data.status?.S;
                if (data.status?.S?.toLowerCase() == APPROVED.toLowerCase()) {
                    return response.Items;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (error: any) {
            let errorMessage = 'Unexpected error';

            switch (error.name) {
                case 'ProvisionedThroughputExceededException':
                case 'RequestLimitExceeded':
                    errorMessage = 'Request limit exceeded';
                    break;
                case 'ResourceNotFoundException':
                    errorMessage = 'Resource not found';
                    break;
                case 'ConditionalCheckFailedException':
                    errorMessage = 'Conditional check failed';
                    break;
                case 'InternalServerError':
                    errorMessage = 'Internal server error';
                    break;
                case 'ValidationException':
                    errorMessage = 'Validation exception';
                    break;
                case 'AccessDeniedException':
                    errorMessage = 'Access denied';
                    break;
                default:
                    errorMessage = error.message || 'Unexpected error';
            }

            setError(errorMessage);
            return null;
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            // const validationErrors = validateForm();
            // if (Object.keys(validationErrors).length > 0) {
            //     setErrors(validationErrors);
            //     return;
            // }

            if (!validateEmail(email)) {
                setError('Invalid email');
                return;
            }

            let hospital_uuid = '';
            let hospital_name = '';
            let hospital_tenant_id = '';
            let nurse_hospital_id = '';
            let user_tenant_id = tenantUuid;
            if (loggedInUserRole.toLowerCase() === HOSPITAL.toLowerCase()) {
                const hospitalItem =
                    await hospitalUserInfo(loggedInUserTenantID);
                if (!hospitalItem) {
                    setError('No hospital found with the given ID.');
                    return; // Stop execution if no hospital is found
                } else {
                    // const hospital_detail = hospitalItem[0];
                    hospital_uuid = hospitalItem.hospital_id
                        ? hospitalItem.hospital_id
                        : '';
                    hospital_name = hospitalItem.hospital_name
                        ? hospitalItem.hospital_name
                        : '';
                    hospital_tenant_id = hospitalItem.tenant_id
                        ? hospitalItem.tenant_id
                        : '';
                    hospital_name = hospitalItem?.hospital_name
                        ? hospitalItem?.hospital_name
                        : '';
                    nurse_hospital_id = hospitalItem?.hospital_id
                        ? hospitalItem?.hospital_id
                        : '';
                    user_tenant_id = hospital_tenant_id;
                }
            } else if (userRole.toLowerCase() === NURSE.toLowerCase()) {
                const hospitalItem = await getItemFromDynamoDB(
                    hospitalID.toLowerCase()
                );
                if (hospitalItem && hospitalItem.length == 0) {
                    setError('No hospital found with the given ID.');
                    return; // Stop execution if no hospital is found
                }
                if (hospitalItem) {
                    const hospital_detail = hospitalItem[0];
                    hospital_uuid = hospital_detail.hospital_id?.S
                        ? hospital_detail.hospital_id?.S
                        : '';
                    hospital_name = hospital_detail.hospital_name?.S
                        ? hospital_detail.hospital_name?.S
                        : '';
                    hospital_tenant_id = hospital_detail.tenant_id?.S
                        ? hospital_detail.tenant_id?.S
                        : '';
                    hospital_name = hospital_detail?.hospital_name?.S
                        ? hospital_detail?.hospital_name?.S
                        : '';
                    nurse_hospital_id = hospital_detail?.hospital_id?.S
                        ? hospital_detail?.hospital_id?.S
                        : '';
                    user_tenant_id = hospital_detail?.tenant_id?.S
                        ? hospital_detail.tenant_id?.S
                        : '';
                }
            }

            // if (deviceUniqueID) {
            //     try {
            //         const res = await checkDeviceIdExists(deviceUniqueID);
            //         if (res == 'Device ID exists') {
            //             setError(res);
            //             return;
            //         }
            //     } catch (error: any) {
            //         setError(error);
            //     }
            // }

            const pathname = location.pathname;

            const userData = [
                {
                    Name: USER_EMAIL,
                    Value: email,
                },
                {
                    Name: USER_MOBILE_NUMBER,
                    Value: mobileNumber,
                },
                {
                    Name: USER_ROLE,
                    Value: userRole,
                },
                {
                    Name: 'email_verified',
                    Value: 'true',
                },
                {
                    Name: 'custom:tenant_id',
                    Value: user_tenant_id,
                },
                {
                    Name: 'custom:device_id',
                    Value: deviceUniqueID,
                },
            ];

            const res = await adminCreateUser(email, userData, password);
            const attributes = await getUserAttributes();

            if (typeof attributes !== 'string' && attributes !== null) {
                const updated_By = attributes[TENANT_ID] ?? '';
                const userId = attributes[COGNITO_USER_ID] ?? '';
                if (res.id) {
                    //     // await setUserID(res.id);
                    //     console.log('res', res);
                    //     console.log('res.id', res.id);
                    setUserID(res.id);
                    const userNameOrHospitalName =
                        userRole.toLowerCase() === HOSPITAL.toLowerCase()
                            ? hospitalName
                            : userName;
                    const userSlug = generateSlug(userNameOrHospitalName);
                    setSlugName(userSlug);
                    const data = {
                        id: tenantUuid,
                        hospital_uuid: hospitalUuid,
                        hospitalInfo_uuid: hospitalInfoUuid,
                        userInfo_uuid: userInfoUuid,
                        logoName: logo_name,
                        logoUrl: logo_url,
                        logoType: logo_type,
                        role: userRole,
                        name: userName,
                        userEmail: email,
                        userMobile: mobileNumber,
                        userDeviceId: deviceUniqueID,
                        addressOne: userAddressOne,
                        addressTwo: userAddressTwo,
                        city: userCity,
                        state: userState,
                        country: userCountry,
                        pincode: userPincode,
                        status: APPROVED,
                        slug: userSlug,
                        userId: res.id,
                        gst: hospitalGST,
                        hospitalId:
                            loggedInUserRole.toLowerCase() ==
                            HOSPITAL.toLowerCase()
                                ? hospital_uuid.toLowerCase()
                                : hospitalID.toLowerCase(),
                        hospitalName:
                            loggedInUserRole.toLowerCase() ==
                            HOSPITAL.toLowerCase()
                                ? hospital_name
                                : hospitalName,
                        hospitalBranch: hospitalBranchName,
                        hospitalEmailID: hospitalEmailID,
                        hospitalWebsite: hospitalWebsite,
                        hospitalContactNumber: hospitalContactNumber,
                        hospitalTelephoneNumber: hospitalTelephone,
                        tenant_id: user_tenant_id,
                        approvedBy: userId,
                        updatedBy: userId,
                    };

                    // console.log('data', data);
                    // console.log('hospital_uuid', hospital_uuid);
                    // console.log('hospitalName', hospitalName);
                    // console.log('hospitalID', hospitalID);

                    await userInfo(data);
                    addLog(
                        'User Created',
                        userInfoUuid,
                        'User',
                        loggedInUserID,
                        { 'User': email, 'Role': data.role },
                        window.location.hostname
                    );
                }
            }
        } catch (error: any) {
            // setError(error);
            // setError(error.message || String(error));
            let errorMessage;
            switch (error.name) {
                case 'UserNotFoundException':
                    errorMessage = 'User not found.';
                    break;
                case 'UsernameExistsException':
                    errorMessage = 'Email already exists.';
                    break;
                case 'InvalidParameterException':
                    errorMessage = 'Invalid parameters provided.';
                    break;
                case 'LimitExceededException':
                    errorMessage = 'Limit exceeded.';
                    break;
                case 'InternalErrorException':
                    errorMessage = 'Internal server error.';
                    break;
                default:
                    errorMessage =
                        error.message || 'An unknown error occurred.';
            }
            setError(errorMessage);
        } finally {
            setShowModal(true);
        }

        // navigate('/users'); // Uncomment this line to navigate after successful user creation
    };

    function getFormattedDate() {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    const handleRowClick = async () => {
        const date = getFormattedDate();
        // if () {}
        if (userRole.toLowerCase() === HOSPITAL.toLowerCase()) {
            // const res = await getUserIDInfo('user_info', userID);
            const res = await getDataUsingUserId('user_info', userID);

            if (res && res.Items && res.Items.length > 0) {
                const additionalDetails = res.Items[0];
                const mergedUserDetails = {
                    id: userID,
                    tenantUUid: additionalDetails?.tenant_id?.S
                        ? additionalDetails?.tenant_id?.S
                        : '',
                    device_id: deviceUniqueID,
                    hospital_id: additionalDetails.hospital_id?.S
                        ? additionalDetails.hospital_id?.S
                        : '--',
                    hospital_name: hospitalName ? hospitalName : '--',
                    hospital_branch: hospitalBranchName
                        ? hospitalBranchName
                        : '--',
                    hospital_website: hospitalWebsite,
                    gst_no: hospitalGST ? hospitalGST : '--',
                    contact_no: hospitalContactNumber
                        ? hospitalContactNumber
                        : '--',
                    email_id: hospitalEmailID,
                    address: `${userAddressOne}, ${userAddressTwo}`,
                    admin_name: userName,
                    mobile_no: mobileNumber,
                    admin_email: email,
                    create_date: date,
                    hospital_admin_status: APPROVED,
                    logo: logo_url || null,
                    approvedOn: date,
                };
                dispatch(setHospitalDetail(mergedUserDetails));
                navigate(`/hospital-users/${slugName}`);
            }
        } else if (userRole.toLowerCase() === INDIVIDUAL.toLowerCase()) {
            const res = await getDataUsingUserId('user_info', userID);
            const attributes = await getUserAttributes();

            if (
                res &&
                res.Items &&
                res.Items.length > 0 &&
                typeof attributes !== 'string' &&
                attributes !== null
            ) {
                const additionalDetails = res.Items[0];
                const mergedUserDetails = {
                    id: userID,
                    tenantUUid: tenantUuid,
                    name: userName,
                    status: 'not verified',
                    device_id: deviceUniqueID,
                    email_id: email,
                    contact_id: mobileNumber,
                    create_date: date,
                    address: `${userAddressOne}, ${userAddressTwo}`,
                };
                dispatch(setUserDetail(mergedUserDetails));
                navigate(`/individual-users/${slugName}`);
            }
        } else if (userRole.toLowerCase() === NURSE.toLowerCase()) {
            const res = await getDataUsingUserId('user_info', userID);
            const attributes = await getUserAttributes();

            if (
                res &&
                res.Items &&
                res.Items.length > 0 &&
                typeof attributes !== 'string' &&
                attributes !== null
            ) {
                if (
                    res &&
                    typeof attributes !== 'string' &&
                    attributes !== null
                ) {
                    const additionalDetails = res.Items[0];

                    let approved_By = '--';
                    if (additionalDetails.approved_by?.S) {
                        const assigned = await getDataUsingUserId(
                            'user_info',
                            additionalDetails.approved_by?.S
                                ? additionalDetails.approved_by?.S
                                : ''
                        );

                        if (
                            assigned &&
                            assigned.Items &&
                            assigned.Items.length > 0
                        ) {
                            const data = assigned.Items[0];
                            approved_By = data.name?.S ? data.name?.S : '';
                        }
                    }

                    const created = await getDataUsingUserId(
                        'user_info',
                        additionalDetails.created_by?.S
                            ? additionalDetails.created_by?.S
                            : ''
                    );

                    let created_By = '--';
                    if (created && created.Items && created.Items.length > 0) {
                        const userdata = created.Items[0];
                        created_By = userdata.name?.S ? userdata.name?.S : '';
                    }

                    const updated_By = attributes[TENANT_ID] ?? '';
                    const mergedUserDetails = {
                        id: userID,
                        tenantUUid: tenantUuid,
                        name: userName,
                        status: additionalDetails.status?.S
                            ? additionalDetails.status?.S
                            : '',
                        deviceId: deviceUniqueID,
                        hospitalId: additionalDetails.hospital_id?.S
                            ? additionalDetails.hospital_id?.S
                            : '',
                        hospitalName: additionalDetails.hospital_name?.S
                            ? additionalDetails.hospital_name?.S
                            : '',
                        email_id: email,
                        contact_id: mobileNumber,
                        approvedBy: approved_By,
                        createdBy: created_By,
                        createdAt: date,
                        address: `${userAddressOne}, ${userAddressTwo}`,
                        nurseId: additionalDetails.nurse_id?.S
                            ? additionalDetails.nurse_id?.S
                            : '',
                    };
                    // console.log('merge', mergedUserDetails);
                    dispatch(setNurseDetail(mergedUserDetails));
                    if (
                        loggedInUserRole.toLowerCase() == HOSPITAL.toLowerCase()
                    ) {
                        navigate(`/management/nurse/${slugName}`);
                    } else {
                        navigate(`/nurse-users/${slugName}`);
                    }
                }
            }
        }
    };

    const backArrow = () => {
        // console.log(pathname);
        // Check if the pathname matches any of the paths from AppConfig
        // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
        //     navigate(HOSPITAL_USER_PATH);
        // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
        //     navigate(INDIVIDUAL_USER_PATH);
        // } else if (pathname.startsWith(NURSE_PATH + '/')) {
        //     navigate(NURSE_PATH);
        // }
        navigate(-1);
    };
    return (
        <>
            <div className="mx-auto px-5">
                <div className="font-bold text-black text-base">
                    {/* <Link to={HOSPITAL_USER_PATH}> */}
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={backArrow}
                    >
                        <FaArrowLeftLong className="" />{' '}
                        <h2 className="font-semibold ml-2">{buttonText}</h2>
                    </div>
                    {/* </Link> */}
                </div>
                {error && <ErrorMessage message={error} />}
                <div className="cart relative mx-auto bg-white rounded-2xl p-5 mt-5 w-11/12">
                    <form onSubmit={handleSubmit} className="w-10/12 mx-auto">
                        {userRole == HOSPITAL && <HospitalForm />}

                        {userRole == NURSE && <NurseForm />}

                        {userRole == INDIVIDUAL && <IndividualForm />}
                        <div className="  col-span-2 pb-14 absolute flex -bottom-40 left-1/2 -translate-x-2/4 cursor-pointer justify-center w-full">
                            <button
                                className="bg-primary text-lg text-white py-2  px-4 rounded-lg w-2/6"
                                type="submit"
                            >
                                {t('auth.signup.submit')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <SuccessPopUp
                show={showModal}
                message={t('pop_up.user_created')}
                onConfirm={handleRowClick}
                onCancel={backArrow}
            />
        </>
    );
};

export default CreateUser;
